import React from "react";
import SidebarStepSlider from '../sliders/SidebarStepSlider.jsx'

import { useRecoilState } from "recoil";
import { layerDefOpacitySelector } from "../../layers/recoil";

const MIN_OPACITY = 0;
const MAX_OPACITY = 1;
const STEP_SIZE = (MAX_OPACITY - MIN_OPACITY) / 10;

export default function TransparencySlider({ layerID }) {
  const [opacity, setOpacity] = useRecoilState(
    layerDefOpacitySelector(layerID)
  );

  if (typeof opacity !== "number") {
    return null;
  }

  const updateOpacity = (value) => {
    value = Math.round(value * 10) / 10;
    setOpacity(value)
  }

  return (
    <SidebarStepSlider
      title="Transparency"
      min={MIN_OPACITY}
      max={MAX_OPACITY}
      step={STEP_SIZE}
      value={opacity}
      updateValue={updateOpacity}
      incrementLabal="Increase the opacity of the layer"
      decrementLabal="Decrease the opacity of the layer" />
  )
}
